import clsx from 'clsx'
import { Document, FileTemplate, XClose } from '@/assets/icons'

export type FileAttachmentChipVariant = 'file' | 'template'
export type FileAttachmentChipSize = 'default' | 'large'

export type FileAttachmentChipProps = {
  name: string
  variant?: FileAttachmentChipVariant
  size?: FileAttachmentChipSize
  onDismiss?: () => void
}

export function FileAttachmentChip({ name, variant = 'file', size = 'default', onDismiss }: FileAttachmentChipProps) {
  const isLarge = size === 'large'
  const isTemplate = variant === 'template'
  const Icon = isTemplate ? FileTemplate : Document

  return (
    <div
      data-ds-component="FileAttachmentChip"
      className={clsx(
        'group inline-flex min-w-0 max-w-full self-start items-center gap-1 rounded px-2',
        isLarge ? 'py-1.5' : 'py-1',
        isTemplate
          ? onDismiss
            ? 'bg-brand-neutral-300 hover:bg-brand-neutral-400'
            : 'bg-brand-neutral-300'
          : onDismiss
          ? 'border border-brand-neutral-200 bg-brand-neutral-50 hover:bg-brand-neutral-100'
          : 'border border-brand-neutral-200 bg-brand-neutral-50'
      )}
    >
      <div className="flex min-w-0 items-center gap-1.5">
        <Icon
          className={clsx(
            'shrink-0',
            isLarge ? 'size-5' : 'size-[18px]',
            isTemplate ? 'text-brand-neutral-950' : onDismiss ? 'text-brand-neutral-800 group-hover:text-brand-neutral-950' : 'text-brand-neutral-800'
          )}
        />
        <span
          className={clsx(
            'truncate font-medium',
            isLarge ? 'text-sm leading-5 tracking-[-0.15px]' : 'text-xs leading-4',
            isTemplate ? 'text-brand-neutral-950' : onDismiss ? 'text-brand-neutral-800 group-hover:text-brand-neutral-950' : 'text-brand-neutral-800'
          )}
        >
          {name}
        </span>
      </div>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label={`Remove ${name}`}
          className="shrink-0 rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500"
        >
          <XClose className={isLarge ? 'size-5' : 'size-[18px]'} />
        </button>
      )}
    </div>
  )
}
